// extracted by mini-css-extract-plugin
export default {"main":"ddf27f5793 _1ea5f8ea48 e618fd0cdf fa197b96ff","title":"b00e6b7065"};